// Analytic three-segment limb solver. Both endpoint anchors remain authoritative;
// anatomical guide points choose a consistent joint plane without frame history.
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const direction={x:0,y:0,z:0},bend={x:0,y:0,z:0};
const distance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y,a.z-b.z);

function sphereJoint(a,b,radiusA,radiusB,guide,out){
 const d=Math.max(1e-9,distance(a,b));direction.x=(b.x-a.x)/d;direction.y=(b.y-a.y)/d;direction.z=(b.z-a.z)/d;
 const along=clamp((radiusA*radiusA+d*d-radiusB*radiusB)/(2*d),-radiusA,radiusA),height=Math.sqrt(Math.max(0,radiusA*radiusA-along*along));
 const gx=guide.x-a.x,gy=guide.y-a.y,gz=guide.z-a.z,projection=gx*direction.x+gy*direction.y+gz*direction.z;
 bend.x=gx-direction.x*projection;bend.y=gy-direction.y*projection;bend.z=gz-direction.z*projection;
 let length=Math.hypot(bend.x,bend.y,bend.z);
 if(length<1e-9){bend.x=direction.z;bend.y=0;bend.z=-direction.x;length=Math.hypot(bend.x,bend.z);if(length<1e-9){bend.x=1;bend.y=0;bend.z=0;length=1;}}
 out.x=a.x+direction.x*along+bend.x/length*height;out.y=a.y+direction.y*along+bend.y/length*height;out.z=a.z+direction.z*along+bend.z/length*height;
 return out;
}

/**
 * lengths = hip→knee, knee→hock, hock→hoof, and preferred hip→hock span.
 * Guides are transformed anatomical rest points. Minimal uniform extension is
 * returned explicitly when breathing/terrain makes fixed endpoints unreachable.
 */
export function solveThreeBoneLimb(hip,hoof,lengths,kneeGuide,hockGuide,out){
 const d=distance(hip,hoof),total=lengths[0]+lengths[1]+lengths[2],stretch=Math.max(1,d/Math.max(total,1e-9));
 const a=lengths[0]*stretch,b=lengths[1]*stretch,c=lengths[2]*stretch;
 const lower=Math.max(Math.abs(a-b),Math.abs(d-c)),upper=Math.min(a+b,d+c),span=clamp(lengths[3]*stretch,Math.min(lower,upper),Math.max(lower,upper));
 sphereJoint(hip,hoof,span,c,hockGuide,out.hock);sphereJoint(hip,out.hock,a,b,kneeGuide,out.knee);out.stretch=stretch;return out;
}

/** Analytic two-bone chain with explicit authored lengths and a stable pole. */
export function solveTwoBoneLimb(hip,ankle,lengths,guide,out){
 const span=distance(hip,ankle),total=lengths[0]+lengths[1],inner=Math.abs(lengths[0]-lengths[1]),stretch=Math.max(1,span/Math.max(total,1e-9)),compression=inner>1e-9?Math.min(1,span/inner):1;
 // Fixed endpoints inside an unequal chain's inner shell cannot preserve both
 // lengths. Report the minimal uniform contraction instead of silently changing
 // one segment. The authored candidate gate rejects excessive deformation.
 if(span<1e-12&&inner>1e-9)Object.assign(out.knee,hip);else sphereJoint(hip,ankle,lengths[0]*stretch*compression,lengths[1]*stretch*compression,guide,out.knee);
 out.stretch=stretch;out.compression=compression;return out;
}
